import { Button } from '@/components/Common';
import iconAudio from '@/assets/icons/playBlack.svg';
import { useAudioUpload } from './useAudioUpload';

interface AudioUploadProps {
  onAudioUpload?: (file: File) => void;
}

const AudioUpload: React.FC<AudioUploadProps> = ({ onAudioUpload }) => {
  const {
    audioUrl,
    audioRef,
    fileInputRef,
    handleFileChange,
    handleUploadClick,
    togglePlayPause,
    onEnded,
  } = useAudioUpload(onAudioUpload);

  return (
    <div className="w-full">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-white text-2xl font-bold">Ajouter un audio</h2>
        <Button
          title="Upload"
          icon={<i className="pi pi-upload"></i>}
          iconPosition="right"
          className="!bg-yellow-500 !text-black !px-5"
          onClick={handleUploadClick}
        />
        <input
          type="file"
          accept="audio/*"
          className="hidden"
          ref={fileInputRef}
          onChange={handleFileChange}
        />
      </div>

      <div className="relative w-full h-screen flex justify-center items-center">
        {audioUrl ? (
          <audio ref={audioRef} src={audioUrl} onEnded={onEnded} />
        ) : null}

        <button
          onClick={togglePlayPause}
          className="size-16 bg-yellow-500 rounded-full flex items-center justify-center"
        >
          <img src={iconAudio} alt="audio" />
        </button>
      </div>
    </div>
  );
};

export default AudioUpload;
